export default {
  string: 'Text',
  date: 'Date Picker',
  integer: 'Number',
  boolean: 'Check Box',
  list: 'Dropdown Menu'
};
